import React from "react"
import {Box, Link, Typography} from "@mui/material"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline"
import {Link as RouterLink} from "react-router-dom"
import {format} from "date-fns"

import type {UnidentifiedResolution} from "../types"

import {phraseDismissalReason} from "./chips"

function OutcomeCard({resolution}: {resolution: UnidentifiedResolution}) {
	const assigned = resolution.Status === "assigned"

	return (
		<Box display="flex" gap={1.5} alignItems="flex-start">
			<Box color={assigned ? "success.main" : "text.secondary"} display="flex">
				{assigned ? <CheckCircleOutlineIcon /> : <RemoveCircleOutlineIcon />}
			</Box>
			<Box minWidth={0}>
				<Typography variant="subtitle2">
					{resolution.Status === "assigned"
						? `Assigned to ${resolution.CustomerName}`
						: `Dismissed · ${phraseDismissalReason(resolution.Reason)}`}
				</Typography>
				<Typography variant="body2" color="textSecondary">
					{resolution.By && `by ${resolution.By} · `}
					{format(new Date(resolution.At), "d MMM yyyy, HH:mm")}
				</Typography>
				{resolution.Status === "assigned" && (
					<Box mt={1}>
						<Link
							component={RouterLink}
							to={`/customers/${resolution.CustomerID}`}
							variant="body2"
							underline="hover"
						>
							Open {resolution.CustomerName} →
						</Link>
					</Box>
				)}
				{resolution.Status === "dismissed" && (
					<>
						{resolution.Note && (
							<Typography variant="body2" mt={0.75}>
								{resolution.Note}
							</Typography>
						)}
						<Typography variant="body2" color="textSecondary" mt={0.75}>
							A dismissal only closes the queue item.
						</Typography>
					</>
				)}
			</Box>
		</Box>
	)
}

export {OutcomeCard}
